import { render, staticRenderFns } from "./adesao.vue?vue&type=template&id=73a31551&scoped=true"
import script from "./adesao.vue?vue&type=script&lang=js"
export * from "./adesao.vue?vue&type=script&lang=js"
import style0 from "./adesao.vue?vue&type=style&index=0&id=73a31551&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a31551",
  null
  
)

export default component.exports